import { Helmet } from 'react-helmet-async'

import { SeoProps } from './index'

/**
 * og: - Facebook Meta Tags
 * twitter: Twitter Meta Tags
 * itemProp - Google / Search Engine Tags
 *
 * if you are adding new tag - keep in mind to add 'key' or 'name' unique attribute
 */
function Seo({
  title,
  description,
  keywords,
  preview,
  children,
  type = 'website',
}: SeoProps): JSX.Element {
  const previewSrc = preview ?? '/preview.jpg'
  return (
    <Helmet>
      {title != null && <title key='title'>{title}</title>}
      {title != null && <meta key='og:title' property='og:title' content={title} />}
      {title != null && <meta name='twitter:title' content={title} />}
      {title != null && <meta key='google:name' itemProp='name' content={title} />}

      {description != null && <meta name='description' content={description} />}
      {description != null && (
        <meta key='og:description' property='og:description' content={description} />
      )}
      {description != null && <meta name='twitter:description' content={description} />}
      {description != null && (
        <meta key='google:description' itemProp='description' content={description} />
      )}

      {previewSrc != null && <meta key='og:image' property='og:image' content={previewSrc} />}
      {previewSrc != null && <meta name='twitter:image' content={previewSrc} />}
      {previewSrc != null && <meta key='google:image' itemProp='image' content={previewSrc} />}

      {keywords != null && <meta name='keywords' content={keywords} />}

      <meta key='og:type' property='og:type' content={type} />
      <meta key='og:site_name' property='og:site_name' content='gameskinx - Official Website' />
      <meta name='twitter:card' content='summary_large_image' />
    </Helmet>
  )
}

export default Seo
